import React from "react";
import "./ProfileSidebar.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  currentOrganizationSelector,
  userSelector,
} from "../../store/selectors";
import ProfileMainIcon from "../../assets/profile-main.svg";
import ProfileBillingIcon from "../../assets/profile-billing.svg";
import ProfileNotificationsIcon from "../../assets/profile-notifications.svg";
import ProfileSecurityIcon from "../../assets/profile-security.svg";
import ProfileTeamIcon from "../../assets/users.svg";
import ProfileActiveSessionsIcon from "../../assets/profile-active-sessions.svg";
import ProfileSupportIcon from "../../assets/SupportIcon.svg";
import useIsMobile from "../../hooks/useIsMobile";

const ProfilePopup = ({ activeTab = "profile", subActive = "" }) => {
  const user = useSelector(userSelector);
  const isMobile = useIsMobile();
  const currentOrg = useSelector(currentOrganizationSelector);
  const navigate = useNavigate();

  return (
    <aside className={isMobile ? "profile-sidebar-mobile" : "profile-sidebar"}>
      <nav>
        <ul>
          <li
            onClick={() => navigate("/profile", { replace: true })}
            className={`${activeTab === "profile" ? "active" : ""}`}
          >
            <img
              src={ProfileMainIcon}
              alt="notifications"
              stroke="green"
              width={20}
              style={{ marginRight: 5 }}
              height={20}
            />
            Профиль
          </li>
          <li
            onClick={() => navigate("/team", { replace: true })}
            className={`${activeTab === "team" ? "active" : ""}`}
          >
            <img
              src={ProfileTeamIcon}
              alt="notifications"
              // stroke="green"
              width={16}
              fill="red"
              style={{ marginRight: 8, marginLeft: 2 }}
              height={16}
            />
            {/* Доступы{` ${(currentOrg && "(" + currentOrg.title + ")") || ""}`} */}
            Доступы и команда
          </li>
          {!!user.role && user.role === "ADMIN" && (
            <>
              <li
                className={`${activeTab === "admin" ? "active" : ""}`}
                style={{ paddingBottom: 6 }}
                onClick={() =>
                  navigate("/profile/admin/dashboard", { replace: true })
                }
              >
                <img
                  src={ProfileMainIcon}
                  alt="notifications"
                  stroke="green"
                  width={20}
                  style={{ marginRight: 5 }}
                  height={20}
                />
                Админка
              </li>
              <li
                className={`sub-item ${subActive === "stats" ? "active" : ""}`}
                onClick={() =>
                  navigate("/profile/admin/dashboard", { replace: true })
                }
              >
                {/* <img
                    src={ProfileTeamIcon}
                    alt="notifications"
                    // stroke="green"
                    width={16}
                    fill="red"
                    style={{ marginRight: 8, marginLeft: 2 }}
                    height={16}
                  /> */}
                Дашборд
              </li>
              <li
                className={`sub-item ${
                  subActive === "tariffes" ? "active" : ""
                }`}
                onClick={() =>
                  navigate("/profile/admin/tariffes", { replace: true })
                }
              >
                {/* <img
                    src={ProfileTeamIcon}
                    alt="notifications"
                    // stroke="green"
                    width={16}
                    fill="red"
                    style={{ marginRight: 8, marginLeft: 2 }}
                    height={16}
                  /> */}
                Тарифы
              </li>
              <li
                className={`sub-item ${
                  subActive === "organizations" ? "active" : ""
                }`}
                onClick={() =>
                  navigate("/profile/admin/organizations", { replace: true })
                }
              >
                Организации
              </li>
              <li
                className={`sub-item ${
                  subActive === "reactions" ? "active" : ""
                }`}
                onClick={() =>
                  navigate("/profile/admin/reactions", { replace: true })
                }
              >
                Реакции
              </li>
              <li
                className={`sub-item ${
                  subActive === "reaction-packs" ? "active" : ""
                }`}
                onClick={() =>
                  navigate("/profile/admin/reaction-packs", { replace: true })
                }
              >
                Паки реакций
              </li>
              <li
                className={`sub-item ${
                  subActive === "agreements" ? "active" : ""
                }`}
                onClick={() =>
                  navigate("/profile/admin/agreements", { replace: true })
                }
              >
                Соглашения
              </li>
            </>
          )}
          <li
            onClick={() => navigate("/pricing", { replace: true })}
            className={`${activeTab === "tariffes" ? "active" : ""}`}
          >
            <img
              src={ProfileBillingIcon}
              alt="notifications"
              stroke="green"
              width={20}
              style={{ marginRight: 5 }}
              height={20}
            />
            Тарифный план
          </li>
          <li
            onClick={() => navigate("/notifications", { replace: true })}
            className={`${activeTab === "notifications" ? "active" : ""}`}
          >
            <img
              src={ProfileNotificationsIcon}
              alt="notifications"
              stroke="green"
              width={20}
              style={{ marginRight: 5 }}
              height={20}
            />
            Уведомления
          </li>
          <li
            onClick={() => navigate("/security", { replace: true })}
            className={`${activeTab === "security" ? "active" : ""}`}
          >
            <img
              src={ProfileSecurityIcon}
              alt="notifications"
              stroke="green"
              width={20}
              style={{ marginRight: 5 }}
              height={20}
            />
            Безопасность
          </li>
          <li
            onClick={() => navigate("/active-sessions", { replace: true })}
            className={`${activeTab === "active-sessions" ? "active" : ""}`}
          >
            <img
              src={ProfileActiveSessionsIcon}
              alt="notifications"
              stroke="green"
              width={20}
              style={{ marginRight: 5 }}
              height={20}
            />
            Активные сессии
          </li>
          <li
            onClick={() => navigate("/support", { replace: true })}
            className={`${activeTab === "support" ? "active" : ""}`}
          >
            <img
              src={ProfileSupportIcon}
              alt="notifications"
              stroke="green"
              width={20}
              style={{ marginRight: 5 }}
              height={20}
            />
            Поддержка
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default ProfilePopup;
